import { render, staticRenderFns } from "./OrdersPdf.vue?vue&type=template&id=64be5bd2&"
import script from "./OrdersPdf.vue?vue&type=script&lang=js&"
export * from "./OrdersPdf.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports